export const RIBBON_ON_CHANGE_EVENT = 'RIBBON_ON_CHANGE_EVENT'
